import QuestionModel from '@/dex-shared/models/QuestionModel';
import ContentModel from '@/dex-shared/models/ContentModel';

export default {
  questionById: (state: any, getters: any) => (questionId: number) => {
    let question = state.questions[questionId];
    if (question) {
      return new QuestionModel(question, getters);
    } else {
      return {};
    }
  },
  contentsByQuestionId: (state: any, getters: any) => (questionId: number) => {
    return Object.values(state.contents)
      .map((content: any) => new ContentModel(content, getters))
      .filter((content: ContentModel) => content.questionId === questionId);
  },
};
